import * as Yup from "yup";
import axios from "axios";
import React, { useState, useEffect } from "react";
import {  useHistory } from "react-router";
import { Formik, Form } from "formik";
import { useParams } from "react-router-dom";
import { TextInput, } from "../../components/utilityComponent/form-fields";
import { toast } from "react-toastify"
import Cookies from 'js-cookie'
import SyncLoader from "react-spinners/SyncLoader";
import { css } from "@emotion/react";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ckConfig from "../../config/ck-config";

const faqSchema = Yup.object({
    title: Yup.string()
        .trim()
        .min(2, "Minimum of two keywords required")
        .max(50, "Maximum of 50 keywords allowed")
        .required("Help/Faq title is required"),
    desc: Yup.string().trim().required("Description is required")
});


const NewHelpFaqForm = () => {

    const history = useHistory();
    const [faq, setFaq] = useState(null);
    const [initialValues, setInitialValues] = useState({
        title: "",
        type: "general",
        desc: ""
    });
    const [valuesLoaded, setValuesLoaded] = useState(false);
    const { faqId } = useParams();
    const [loading, setLoading] = useState(false);
    const [disable, setDisable] = useState(false)
    const [color, setColor] = useState("#ffffff");

    const override = css`
      display: block;
      margin: 0 auto;
      border-color: red;
    `;

    useEffect(() => {
        // let product = useSelector((state) => { return state.productDetails.listing; })

        if (faqId) {
            fetchFaqs()
        }
    }, [])

    useEffect(() => {
        if (faq) {
            console.log("faq set!!!")
            let data = { ...faq }
            delete data._id
            setInitialValues({ ...faq }); // 
            console.log("faq title: ", faq.title);
        }
    }, [faq])

    useEffect(() => {
        if (!valuesLoaded && faqId && faq)
            setValuesLoaded(true)
        else if (!faqId)
            setValuesLoaded(true);
    }, [initialValues])

    /** State */

    const fetchFaqs = async () => {
        const response = await axios.request({
            headers: {
                'Content-Type': 'application/json',
                'Authorization': Cookies.get('token')
            },
            method: 'get',
            url: `${process.env.REACT_APP_SERVER_URL}/v1/cms/get-faq-by-id?id=${faqId}`
        });
        setFaq(response.data);
    }

    const handleOnChange = (e) => {
        const { name, value } = e.target;
        setInitialValues({ ...initialValues, [name]: value });
    };

    const onSubmit = async (values) => {
        setLoading(true);
        setDisable(true);
        if (faqId) {
            const callback = async () => {
                setLoading(false);
                setDisable(false);
                toast.success("Help/Faq successfully updated!");
                history.push("/cms-help-faq");
            };
            const response = await axios.request({
                data: { id: faqId, title: values.title, type: values.type, desc: values.desc },
                headers:{
                    'Content-Type': 'application/json',
                    'Authorization': Cookies.get('token')
                },
                method: 'put',
                url: `${process.env.REACT_APP_SERVER_URL}/v1/cms/edit-help-faq`
            })
            callback()
            console.log("response for editing faq: ", response.data);

        } else {
            const callback = async () => {
                setLoading(false);
                setDisable(false);
                toast.success("Help/Faq successfully saved!");
                history.push("/cms-help-faq");
            };
            const response = await axios.request({
                data: { title: values.title, type: values.type, desc: values.desc },
                headers:{
                    'Content-Type': 'application/json',
                    'Authorization': Cookies.get('token')
                },
                method: 'post',
                url: `${process.env.REACT_APP_SERVER_URL}/v1/cms/add-help-faq`
            })
            callback()
            console.log("response for adding faq: ", response.data);
        }
    };

    const onEditorChange = (event, editor) => {
        console.log("ck editor on change event called!");
        const data = editor.getData();
        if (valuesLoaded)
            setInitialValues({ ...initialValues, desc: data });
        // console.log({ event, editor, data });
    }

    return (
        <>
            <div className="dashContentHeader px-5 mb-3 row">
                <h5 className="dashHeading mb-0 fontfammedium p-0">
                    {faqId ? "Edit Help/Faq" : "Add New Help/Faq"}
                </h5>

            </div>
            <div className="row dashboardCardRow px-5">
                <div className="col-lg-8 bg-white mt-5 shadow">
                    <Formik
                        initialValues={initialValues}
                        validationSchema={faqSchema}
                        onSubmit={onSubmit}
                        enableReinitialize
                    >
                        {({ errors, values }) => (
                            console.log("Errors : ", errors),
                            (
                                <Form className="mg-login new-product mt-4 px-3">
                                    <div className="row mb-0">
                                        <div className="col-md-12 mb-4 form-group">
                                            <TextInput
                                                label="Help/Faq Title"
                                                name="title"
                                                id="title"
                                                type="text"
                                                placeholder="Enter faq title here"
                                                className="form-control "
                                                onChange={handleOnChange}
                                                isRequired
                                                errors={errors}
                                            />
                                        </div>
                                        <div className="col-md-12 mb-4 form-group">
                                            <label htmlFor="type">Help/Faq type</label>
                                            <select
                                                id="type"
                                                name="type"
                                                className="form-control "
                                                onChange={handleOnChange}
                                                value={initialValues.type}
                                            >
                                                <option selected={initialValues.type === "general" ? true : false} value="general">General</option>
                                                <option selected={initialValues.type === "selling" ? true : false} value="selling">Selling</option>
                                                <option selected={initialValues.type === "buying" ? true : false} value="buying">Buying</option>
                                            </select>
                                        </div>
                                        <div className="col-12">
                                            <hr className="w-100 mb-4" />
                                        </div>
                                        <div className="col-md-12 mb-4 form-group">
                                            <label htmlFor="desc">Help/Faq Description</label>
                                            <CKEditor
                                                id="desc"
                                                editor={ClassicEditor}
                                                config={ckConfig.config}
                                                name="desc"
                                                data={initialValues.desc}
                                                onReady={editor => {
                                                    // You can store the "editor" and use when it is needed.
                                                    console.log('Editor is ready to use!', editor);
                                                }}
                                                onChange={onEditorChange}
                                                onBlur={(event, editor) => {
                                                    // console.log('Blur.', editor);
                                                }}
                                                onFocus={(event, editor) => {
                                                    // console.log('Focus.', editor);
                                                }}
                                            />
                                            <div className="invalid-feedback-ckEditor">
                                                {errors["desc"]}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-wrap justify-content-between mb-5">
                                        <button className="mb-5 sub-button mt-4 px-4" onClick={() => history.push("/cms-help-faq")}>Back</button>
                                        <button
                                            type="submit"
                                            disabled={disable}
                                            className="mb-5 sub-button mt-4 px-4"
                                        >
                                            {loading && <SyncLoader color={color} loading={loading} css={override} size={11} />}
                                            {!loading && (faqId ? "Update" : "Submit")}
                                        </button>
                                    </div>
                                </Form>
                            )
                        )}
                    </Formik>
                    <form className="mg-login new-product mt-4 px-3"></form>
                </div>
            </div>
        </>
    );
}

export default NewHelpFaqForm;